

import FETCHING from "../library/fetching";
import UMUM from "../library/umum.js";

export default {
  data() {
    return {
      alert: false,
      simpan1: false,
      model :'',
      inputSelect : [
        {id : '1', nama : 'kiken', alamat : 'beringin'},
        {id : '2',nama : 'Alung', alamat : 'Anawai'},
      ],
      date : '',

      jmlUSulan: '',
      jmlProses: '',
      jmlTerima: '',
      jmlTolak: '',
      list_kelas_penerima: [],
      list_kelas_usulan: [],
      list_rombel : [],

      UMUM : UMUM,
      FETCHING : FETCHING,

      page_first: 1,
      page_last: 0,
      page_limit : 50,
    }
  },
  methods: {

    getjmlUSulan : function() { 
      fetch(this.$store.state.url.URL_DASHBOARD + "jmlUSulan", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        }, 
      })
      .then(res => res.json())
      .then(res_data => {
        this.jmlUSulan = res_data.total
      }); 
    },

    getjmlProses : function() { 
      fetch(this.$store.state.url.URL_DASHBOARD + "jmlProses", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        }, 
      })
      .then(res => res.json())
      .then(res_data => {
        this.jmlProses = res_data.total
      }); 
    },

    getjmlTerima : function() { 
      fetch(this.$store.state.url.URL_DASHBOARD + "jmlTerima", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        }, 
      })
      .then(res => res.json())
      .then(res_data => {
        this.jmlTerima = res_data.total
      }); 
    },

    getjmlTolak : function() { 
      fetch(this.$store.state.url.URL_DASHBOARD + "jmlTolak", {
        method: "POST",
        headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
        }, 
      })
      .then(res => res.json())
      .then(res_data => {
        this.jmlTolak = res_data.total
      }); 
    },

    getKelasUsulan: function() {
      fetch(this.$store.state.url.URL_DASHBOARD + "kelasUsulan", {
            method: "POST",
            headers: {
              "content-type": "application/json",
              authorization: "kikensbatara " + localStorage.token
            },
            body: JSON.stringify({
              
            })
        }).then(res => res.json())
          .then(res_data => {
            this.list_kelas_usulan = res_data.data;

            var list_kelas_usulan = [];
            var hasil = this.list_kelas_usulan;
            for(var i in hasil) {
              list_kelas_usulan.push([
                hasil[i].uraian,
                hasil[i].jmlStatus
              ])
            }
            // console.log(res_data);

            this.kelasUsulanPie(list_kelas_usulan);
        });
      },

    kelasUsulanPie : function(list_kelas_usulan){
      Highcharts.chart('kelasUsulanPie', {
      chart: {
          type: 'pie',
          backgroundColor: 'transparent'
      },
      title: {
          text: 'DATA PERSENTASE USULAN'
      },
      tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      accessibility: {
          point: {
              valueSuffix: '%'
          }
      },
      plotOptions: {
      pie: {
          allowPointSelect: true,
          cursor: 'pointer',
          dataLabels: {
              enabled: false
          },
          showInLegend: true
      }
      },
      series: [{
          name: 'Persentase',
          colorByPoint: true,
          data: list_kelas_usulan
        }]
      });
    },

    getKelasPenerima: function() {
      fetch(this.$store.state.url.URL_DASHBOARD + "kelasPenerima", {
          method: "POST",
          headers: {
            "content-type": "application/json",
            authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
            
          })
      }).then(res => res.json())
        .then(res_data => {
          this.list_kelas_penerima = res_data.data;

          var list_kelas_penerima = [];
          var hasil = this.list_kelas_penerima;
          for(var i in hasil) {
            list_kelas_penerima.push([
              hasil[i].uraian,
              hasil[i].jmlKelasPenerima
            ])
          }
          // console.log(res_data);

          this.kelasPenerimaPie(list_kelas_penerima);
      });
    },

    kelasPenerimaPie : function(list_kelas_penerima){
      Highcharts.chart('kelasPenerimaPie', {
      chart: {
          type: 'pie',
          backgroundColor: 'transparent',
          options3d: {
              enabled: true,
              alpha: 45,
              beta: 0
          }
      },
      title: {
          text: 'DATA PERSENTASE KELAS PENERIMA'
      },
      accessibility: {
          point: {
              valueSuffix: '%'
          }
      },
      tooltip: {
          pointFormat: '{series.name}: <b>{point.percentage:.1f}%</b>'
      },
      plotOptions: {
          pie: {
              allowPointSelect: true,
              cursor: 'pointer',
              depth: 35,
              dataLabels: {
                  enabled: true,
                  format: '{point.name}'
              }
          }
          },
          series: [{
              type: 'pie',
              name: 'Persentase',
              data: list_kelas_penerima
          }]
      });









    },

    getRombel: function(){
      fetch(this.$store.state.url.URL_DASHBOARD + "viewRombel", {
          method: "POST",
          headers: {
          "content-type": "application/json",
          authorization: "kikensbatara " + localStorage.token
          },
          body: JSON.stringify({
              // data_ke: this.page_first,
              // cari_value: this.cari_value,
              // page_limit: this.page_limit,
          })
      })
          .then(res => res.json())
          .then(res_data => {
              this.list_rombel = res_data.data;
              // this.page_last = res_data.jml_data;
              // this.$store.commit("hideLoading");
              // console.log(res_data);
      });
    },



    






    indexing : function(index){
      var idx = ((this.page_first-1)*this.page_limit)+index
      return idx
    },
  },

  mounted () {
    this.getjmlUSulan();
    this.getjmlProses();
    this.getjmlTerima();
    this.getjmlTolak();
    this.getKelasPenerima();
    this.getKelasUsulan();
    this.getRombel();
  },
}
